/**
 * useMemberPermissions — every member's role, scope and schedule.
 *
 * One app-wide fetch, so saving a member's
 * permissions in the details panel also refreshes the annotations in the
 * Users list.
 *
 * Returns `{ byEmail, canManage, loading, error, refetch }`, where byEmail maps
 * a member's email to `{ email, role, scopeId, schedule }` with `schedule`
 * decoded to 168 booleans, or null for no schedule.
 */

import { useAtomValueRawSync, useSetAtom } from 'jotai';

import {
    memberPermissionsAtom,
    refreshMemberPermissionsAtom,
} from '@/state/api/memberPermissionsAtoms';
import type { MemberPermissionsSnapshot } from '@/types/auth';

interface MemberPermissions extends MemberPermissionsSnapshot {
    refetch: () => void;
}

export function useMemberPermissions(): MemberPermissions {
    const snapshot = useAtomValueRawSync(memberPermissionsAtom);
    const refetch = useSetAtom(refreshMemberPermissionsAtom);
    return { ...snapshot, refetch };
}
